import { Dialog } from "@headlessui/react";
import { mdiClose } from "@mdi/js";
import React from "react";
import { joinClasses } from "../../utils/joinClasses";
import { Icon } from "../icon/Icon";
export const ModalWrapper = ({ children, className, initialFocusRef, isOpen = false, size, onClose, }) => (React.createElement(Dialog, { className: joinClasses([`nxm-modal nxm-modal-${size}`, className]), initialFocus: initialFocusRef, open: isOpen, onClose: onClose },
    React.createElement(Dialog.Overlay, { className: "nxm-modal-overlay" }),
    children));
export const ModalPanel = ({ className, children, showCloseButton = true, title, onClose, }) => (React.createElement(Dialog.Panel, { className: joinClasses(["nxm-modal-panel", className]) },
    !!title && (React.createElement(Dialog.Title, { as: "div", className: joinClasses(["nxm-modal-title"], {
            "mr-7": showCloseButton,
        }) }, title)),
    showCloseButton && (React.createElement("button", { className: "nxm-modal-close", onClick: onClose },
        React.createElement(Icon, { path: mdiClose }))),
    children));
export const Modal = ({ children, showCloseButton, title, onClose, ...props }) => (React.createElement(ModalWrapper, { ...props, onClose: onClose },
    React.createElement(ModalPanel, { showCloseButton: showCloseButton, title: title, onClose: onClose }, children)));
